import * as React from 'react';
import { Capacitor } from '@capacitor/core';
import { useRemoteFlag } from '@/hooks/useRemoteFlag';
import { useNativeVipFlag } from '@/hooks/useNativeVipPro';
import { VipPlanNameContext, VipPlanNamePendingContext } from '@/hooks/useVipPlanName';

/** Web follows vip_paywall_web; the apps follow vip_paywall_<platform>. */
export function VipPlanNameProvider({ children }: { children: React.ReactNode }) {
  const native = Capacitor.isNativePlatform();
  const web = useRemoteFlag('vip_paywall_web', { enabled: !native });
  const app = useNativeVipFlag('vip_paywall', native);
  const flag = native ? app : web;
  // The flag can load while a route below is still hydrating (the prerendered
  // homepage has no server-seeded flag). React Query reports it as an urgent
  // update, and an urgent context change makes React throw away that route's
  // server HTML (minified error #421, #1301). Deferred values reach the
  // children at transition priority, which waits for hydration.
  const on = React.useDeferredValue(flag.on);
  const isLoading = React.useDeferredValue(flag.isLoading);
  return (
    <VipPlanNameContext.Provider value={on}>
      <VipPlanNamePendingContext.Provider value={isLoading}>{children}</VipPlanNamePendingContext.Provider>
    </VipPlanNameContext.Provider>
  );
}
